import React, { ReactNode } from 'react'
import { useDispatch } from 'react-redux'
import { setSettingsEditing } from 'client/store/management/managementActions'
import { BaseElement } from 'src/editor/layout/base-element'
import {
  FormElementInterface,
  FormElementTypeEnum,
  FormInterface,
} from 'src/shared/types/entities/form-interface'
import { useManagement } from 'client/store'
import { getSettingsEditing } from 'client/reducers/managementReducer'
import { useUpdateEntity } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'

export interface FormBaseElementProps {
  formEntity: FormInterface
  element: FormElementInterface
  title: string
  children?: ReactNode
}

export const FormBaseElement = ({
  formEntity,
  element,
  title,
  children,
}: FormBaseElementProps) => {
  const dispatch = useDispatch()

  const isEditing = useManagement(getSettingsEditing).elementId === element.id

  const updateEntity = useUpdateEntity<FormInterface>()

  const onEdit = () => {
    dispatch(
      setSettingsEditing({
        id: formEntity.id,
        type: formEntity.type,
        elementId: element.id,
      }),
    )
  }
  const onRemove = () => {
    updateEntity({
      ...formEntity,
      elements: formEntity.elements.filter(e => e.id !== element.id),
    })
  }
  return (
    <BaseElement
      element={element}
      isEditing={isEditing}
      title={title}
      isRemoveAllowed={element.elementType !== FormElementTypeEnum.SubmitButton}
      onEdit={onEdit}
      onRemove={onRemove}
    >
      {children}
    </BaseElement>
  )
}
